// extracted by mini-css-extract-plugin
module.exports = {"modal-heading":"AdminModalChild_modal-heading__Gfjy6","disable-from-to":"AdminModalChild_disable-from-to__m6_d_"};